















































import Vue from "vue"
import { ImageUpload, TelegramNotification, telegramNotificationSendInTypes } from "@/store/types";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
  name: "NotificationsForm",

  props: {
    notification: { type: Object, default: null }
  },

  data() {
    return {
      select: [
        { text: "Chat dos Clientes", value: telegramNotificationSendInTypes.Chat },
        { text: "Canais Cadastrados", value: telegramNotificationSendInTypes.Channel }
      ],
      payload: {
        image: "",
        message: "",
        send_in: telegramNotificationSendInTypes.Chat,
        status: "pending",
        type: "TEXT",
        created_at: new Date()
      } as TelegramNotification
    };
  },

  mounted() {
    if (this.notification) {
      Object.assign(this.payload, this.notification)
      this.payload.status = "pending"
      this.payload.created_at = new Date()
    }
  },

  methods: {
    getFile(file: File) {
      if (!file.type.includes("image")) {
        return this.$store.dispatch("app/showCustomError", "Arquivo não Suportado!");
      }

      const extension = file.name.split(".")[1];

      const reader = new FileReader();
      reader.onload = async ({ target }) => {
        const image: ImageUpload = {
          folder: "/notifications/telegram",
          filename: `${uuidv4()}.${extension}`,
          file: new Uint8Array(target?.result as ArrayBuffer),
          metadata: {
            contentType: file.type,
            size: file.size,
          }
        }

        this.$store.dispatch("uploader/uploadImage", image)
            .then(url => {
              this.payload.image = url
              this.payload.type = "IMAGE"
            })
      };
      reader.readAsArrayBuffer(file);
    },

    save(): void {
      if (!this.validateForm()) return;

      this.$store.dispatch("telegramNotifications/create", this.payload);

      this.$emit("close");
    },

    validateForm(): Boolean {
      // if (!this.payload.sku) {
      //   this.showError("Insira o SKU da oferta!");
      //   return false;
      // }
      return true;
    },

    isFloatNumber(value: any): Boolean {
      return isNaN(parseFloat(value));
    },

    isValidUrl(string: string): boolean {
      try {
        new URL(string);
      } catch (_) {
        return false;
      }

      return true;
    },

    showError(message: string): void {
      this.$store.dispatch("app/showCustomError", message);
    }
  }
})
